import { EntityCombobox } from "@/components/EntityCombobox";
import { contasReceberService } from "@/features/financeiro/services/contasReceberService";

/** Título a receber em aberto, no formato do combobox. */
export interface TituloReceberOpcao {
  id: number;
  numDocumento: string;
  clienteId: number;
  clienteNome: string | null;
  dtVencimento: string;
  valorSaldo: number;
  nroParcela: number;
  qtdParcelas: number;
}

const fmtCur = (v: number) => v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const fmtData = (s: string) => new Date(s).toLocaleDateString("pt-BR", { timeZone: "UTC" });

async function buscarTitulos(termo: string, clienteId?: number | null): Promise<TituloReceberOpcao[]> {
  const r = await contasReceberService.getAll({
    busca: termo || undefined,
    status: "aberto",
    clienteId: clienteId || undefined,
    tamanhoPagina: 20,
    ordenarPor: "vencimento",
    direcao: "asc",
  });
  return r.itens;
}

interface TituloReceberSearchComboboxProps {
  value?: number | null;
  onChange?: (id: number | null) => void;
  /** Título inteiro (para preencher valor, devedor etc.). */
  onSelect?: (titulo: TituloReceberOpcao | null) => void;
  /** Restringe a um cliente. */
  clienteId?: number | null;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * Título a receber EM ABERTO (vencido ou não), buscado por documento, duplicata ou nome do
 * cliente (GET /api/financeiro/contas-receber?status=aberto&busca=). Mostra
 * "Documento — Cliente" e, abaixo, vencimento + saldo. Nunca pede o id do título.
 */
export function TituloReceberSearchCombobox({
  clienteId, placeholder = "Buscar título em aberto...", ...props
}: TituloReceberSearchComboboxProps) {
  return (
    <EntityCombobox<TituloReceberOpcao>
      {...props}
      queryKey={`titulo-receber-aberto-${clienteId ?? 0}`}
      buscar={(termo) => buscarTitulos(termo, clienteId)}
      obterPorId={(id) => contasReceberService.getDetalhe(id)}
      getId={(t) => t.id}
      getCodigo={(t) => t.numDocumento + (t.qtdParcelas > 1 ? ` (${t.nroParcela}/${t.qtdParcelas})` : "")}
      getDescricao={(t) => t.clienteNome ?? `Cliente cód. ${t.clienteId}`}
      getExtra={(t) => `Venc. ${fmtData(t.dtVencimento)} · saldo ${fmtCur(t.valorSaldo)}`}
      placeholder={placeholder}
      placeholderBusca="Documento, duplicata ou nome do cliente..."
    />
  );
}
